var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"bookmark","d":"M2.8 0h14.4v20L10 13.8 2.8 20"}));
}

Bookmark.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
